"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SliderBarNav = require("./SliderBarNav");

var _SliderBarNav2 = _interopRequireDefault(_SliderBarNav);

var _Category = require("./Category");

var _Category2 = _interopRequireDefault(_Category);

var _Item = require("./Item");

var _Item2 = _interopRequireDefault(_Item);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_SliderBarNav2.default.Category = _Category2.default;
_SliderBarNav2.default.Item = _Item2.default;

exports.default = _SliderBarNav2.default;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-slider-bar-nav@0.0.38@@alicd/crui-slider-bar-nav/lib/index.js
// module id = 730
// module chunks = 0